import { useState } from 'react';

interface CopyButtonProps {
  text: string;
  label?: string;
  title?: string;
  /** Pass -1 when the button sits inside an active typing context (e.g.
   *  inside the LeadList docs disclosure) and shouldn't snag Tab. */
  tabIndex?: number;
}

// Per-row clipboard affordance. Same clipboard pattern as the bulk
// Copy buttons in SelectionBar and CopyAllWatchListButton. Flashes a
// transient "Copied ✓" state after success.
export function CopyButton({ text, label = 'Copy ↗', title, tabIndex }: CopyButtonProps) {
  const [copied, setCopied] = useState(false);

  async function doCopy(e: React.MouseEvent) {
    e.preventDefault();
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      const ta = document.createElement('textarea');
      ta.value = text; document.body.appendChild(ta); ta.select();
      document.execCommand('copy'); document.body.removeChild(ta);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  }

  return (
    <button onClick={doCopy}
      title={title ?? `Copy "${text}" to clipboard`}
      tabIndex={tabIndex}
      className="px-2 py-1 text-[10px] border border-border text-text-faint rounded hover:text-text hover:border-border-bright font-mono">
      {copied ? 'Copied ✓' : label}
    </button>
  );
}

// Helper for the watch-list / pool-order name shape — strips the trailing
// " AND" that pool-order ingest preserves on spouse-truncated entries.
export function stripPoolOrderAndSuffix(name: string): string {
  return name.replace(/\s+AND\s*$/i, '').trim();
}
